import { render, staticRenderFns } from "./SalesFilters.vue?vue&type=template&id=46aa35be&"
import script from "./SalesFilters.vue?vue&type=script&lang=js&"
export * from "./SalesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports